<dropdown [view]="groupView"
          [itemsView]="itemsView"
          showEmptyValue="true"
          (onValueChange)="notifyValueChange($event)">
</dropdown>
